import { number } from "prop-types";

const PageLegal = ({ showAll, year, ...rest }) => (
  <p {...rest}>
    ©{year} HOLT Texas, LTD. d/b/a HOLT CAT. All rights reserved HOLT®,
    HOLT CAT®, Texas First Rentals®, HOLT Truck Centers® and HOLT Crane &amp;
    Equipment® are registered trademarks of HOLT Texas, Ltd.
  </p>
);

PageLegal.propTypes = {
  year: number,
};

PageLegal.defaultProps = {
  year: new Date().getFullYear(),
};

export default PageLegal;
